import { Base } from './Base';

const classes = {
  active: 'active',
  hidden: 'hidden',
  option: 'size-guide__option'
};

export class SizeGuide extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.init();
  }

  init() {
    this.bindOptionClickHandler();
  }

  bindOptionClickHandler() {
    this.element.querySelectorAll('.' + classes.option).forEach((option) => {
      option.addEventListener('click', (e) => {
        e.preventDefault();

        const id = option.href.split('#')[1];
        const target = document.getElementById(id);
        const siblings = option.parentNode.querySelectorAll('.' + classes.option);

        siblings.forEach((siblingOption) => {
          if (siblingOption !== option) {
            siblingOption.classList.remove(classes.active);

            const siblingId = siblingOption.href.split('#')[1];
            const siblingTarget = document.getElementById(siblingId);

            if (siblingTarget) {
              siblingTarget.classList.add(classes.hidden);
            }
          }
        });

        option.classList.add(classes.active);
        target.classList.remove(classes.hidden);
      });
    });
  }
}